import { isWebApp } from '@/shared/utils/window'

export function webStaticProps() {
  if (!isWebApp) {
    throw new Error('Cannot access web static urls outside of web app')
  }

  return window.appConfig!.staticProps
}
